import _ from 'lodash';

Vue.component("single-item", {

    name: "single-item",

    props: {
        pleaseSelectOptionVariationId: {
            type: Number,
            default: 0
        },
        initPleaseSelectOption: {
            type: Boolean,
            default: false
        },
        showNetPrices: {
            type: Boolean,
            default: false
        },
        isWishListEnabled: {
            type: Boolean,
            default: false
        },
        itemId: {
            type: Number,
            required: true
        },
        afterKey: Object,
        freitext: Object,
    },

    data() {
        return {
            window: window,
        }
    },

    provide() {
        return {
            itemId: this.$props.itemId
        }
    },

    jsonDataFields: [
        "itemData",
        "attributesData",
        "variations"
    ],

    computed: {
        itemConfig() {
            return App.config.item.itemData;
        },

        isDescriptionTabActive() {
            return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes(
                "all"))
                && !!this.currentVariation.texts.description.length;
        },

        isRecommendedPriceActive() {
            return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes(
                "all");
        },

        isShortDescriptionActive() {
            return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes(
                "all");
        },

        hasShippingCostsCategoryId() {
            return App.config.global.shippingCostsCategoryId > 0;
        },

        isTechnicalDataTabActive() {
            return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes(
                "all"))
                && !!this.currentVariation.texts.technicalData.length;
        },

        variationGroupedProperties() {
            return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
        },

        variationMissingProperties() {
            return this.$store.getters[`${this.itemId}/variationMissingProperties`];
        },

        currentVariation() {
            return _.get(this.$store.state,
                `items[${this.itemId}].variation.documents[0].data`);
        },

        isVariationSelected() {
            return _.get(this.$store.state,
                `items[${this.itemId}].variationSelect.isVariationSelected`);
        },

        attributes() {
            return _.get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
        },

        units() {
            return _.get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
        }
    },

    created() {
        this.$store.dispatch("initVariation", this.itemData);
        this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`,
            this.pleaseSelectOptionVariationId);
        this.$store.dispatch("addLastSeenItem", this.currentVariation.variation.id);

        this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
            itemId: this.itemId,
            attributes: this.attributesData,
            variations: this.variations,
            initialVariationId: this.currentVariation.variation.id,
            isPleaseSelectOption: this.initPleaseSelectOption,
            afterKey: this.afterKey
        });
    },

    methods: {
        getDataField(field) {
            return _.get(this.currentVariation, field);
        },

        getFilteredDataField(field, filter) {
            if (this.$options.filters[filter] !== null && typeof this.$options.filters[filter] !== 'undefined') {
                return this.$options.filters[filter](this.getDataField(field));
            }

            return this.getDataField(field);
        },
    }
});

import { mapState } from 'vuex';
import { debounce } from '../helper/debounce';
import { pathnameEquals } from "../helper/url";
import { defaultValue, isNullOrUndefined } from "../helper/utils";
import UrlService from "../services/UrlService";

Vue.component("item-search", {
    name: "item-search",

    props: {
        showItemImages:
            {
                type: Boolean
            },
        forwardToSingleItem:
            {
                type: Boolean,
                default: App.config.search.forwardToSingleItem
            },
        timeout:
            {
                type: Number,
                default: 200
            }
    },
    data() {
        return {
            isSearchFocused: App.isShopBuilder,
            onValueChanged: null,
            searchString: ""
        };
    },
    created() {
        this.onValueChanged = debounce(searchString => {
            this.autocomplete(searchString);
        }, defaultValue(this.timeout, 200));
    },
    computed:
        {
            hasAutocompleteResults() {
                const item = this.autocompleteResult.item;
                const category = this.autocompleteResult.category;
                const suggestion = this.autocompleteResult.suggestion;
                return App.isShopBuilder || (item && item.length) || (category && category.length) || (suggestion && suggestion.length);
            },
            isShopBuilder() {
                return App.isShopBuilder;
            },
            ...mapState({
                autocompleteResult: state => state.itemSearch.autocompleteResult,
                moduleSearchString: state => state.itemList.searchString
            }),
            appendFacets() {
                let appendFacets = window.appendFacets ? '&' + window.appendFacets : '';

                if (pathnameEquals(App.urls.search) && !appendFacets) {
                    const urlParams = UrlService.getUrlParams(document.location.search);
                    appendFacets = urlParams.facets ? '&facets=' + urlParams.facets : '';
                }

                return appendFacets;
            }
        },
    mounted() {
        this.$nextTick(() => {
            const urlParams = UrlService.getUrlParams(document.location.search);
            this.$store.commit("setItemListSearchString", urlParams.query);
            this.$refs.searchInput.value = !isNullOrUndefined(urlParams.query) ? urlParams.query : "";
        });
    },
    methods:
        {
            search() {
                if (this.$refs.searchInput.value.length) {
                    if (pathnameEquals(App.urls.search)) {
                        window.location = `${App.urls.search}?query=${this.searchString}${this.appendFacets}`;
                    } else {
                        window.open(`${App.urls.search}?query=${this.searchString}${this.appendFacets}`,
                            "_self",
                            false);
                    }
                }
            },
            autocomplete(searchString) {
                if (searchString.length >= 2) {
                    this.$store.dispatch("loadItemSearchAutocomplete", searchString);
                } else {
                    this.$store.commit("setAutocompleteResult",
                        { item: [], category: [], suggestion: [] });
                }
            },
            // hide search, if targetElement of the blur event is not a child of components' root element
            onBlurSearchField(event) {
                const target = event.relatedTarget;
                if (isNullOrUndefined(target) || !isNullOrUndefined(target) && !this.$el.contains(
                    target)) {
                    this.isSearchFocused = false;
                }
            }
        },
    watch:
        {
            // set the current search string, after clicking on a suggestion
            moduleSearchString(newVal) {
                if (newVal && newVal.length) {
                    this.searchString = newVal;
                }
            }
        }
});

window.getEnergieImage = function (name) {
    let map = {
        'A': 'A.png',
        'A+': 'A_plus.png',
        'A++': 'A_plus_plus.png',
        'A+++': 'A_plus_plus_plus.png',
        'B': 'B.png',
        'C': 'C.png',
        'D': 'D.png',
        'E': 'E.png',
        'F': 'F.png',
        'G': 'G.png'
    };

    if (map[name]) {
        return window.pluginPath + '/images/energieklassen/' + map[name];
    }

    return null;
}

window.isClickToCall = function (item) {
    var counter = item.properties.length,
        clicktocall = false;

    for (var i = 0; i < counter; i++) {
        if (item.properties[i].property.id == 41) {
            clicktocall = true;
        }
    }

    return clicktocall;
}
